import { Box, Typography } from "@mui/material";
import React, { FC } from "react";

import Loading from "../Loading/Loading";

interface ILoadingOverlayProps {
  title?: string;
  subTitle?: string;
  noTransparent?: boolean;
}

const GvLoadingOverlay: FC<ILoadingOverlayProps> = ({ title, subTitle, noTransparent }) => {
  return (
    <Box className={`absolute w-full min-h-full rounded-xl overflow-hidden
    ${noTransparent ? "bg-[#F9F6F4]" : "bg-[#faf6f4CC]"} z-[100] top-0 left-0`}>
      <Box className="sticky top-1/2 p-4 text-center">
        <Loading />
        <Typography variant="h3" className="mb-1 mt-2">
          {title}
        </Typography>
        <Typography variant="body1">
          {subTitle}
        </Typography>
      </Box>
    </Box>

  );
};

export default GvLoadingOverlay;
